<div class="flex flex-col gap-3 mb-6">
  <div class="card p-4 flex flex-col items-center gap-2 relative">
    <img src="../../../../../assets/img/balance/available_ganas.svg" class="size-[3.5rem] rounded-full" alt="" />
    <div class="flex flex-col">
      <span class="text-[#003555] text-[2rem]/[140%] md:text-[2.3125rem]/[140%] font-bold text-center">
        {{ availableGanas() | thousandsSeparator }}
      </span>
      <span class="text-[#007DCB] text-[1rem]/[160%] md:text-[1.125rem]/[160%]">
        {{ 'rewards.availableGanas' | translate }}
      </span>
    </div>
    @if (showRecentEarnings()) {
      <div
        class="text-[0.8125rem] md:text-[1.125rem] font-bold border-1 border-solid border-[#8AC3E7] rounded-[0.25rem] bg-[#E6F2FA] absolute top-4 right-4 py-[0.125rem] px-[0.5rem] flex items-center justify-center text-[#003555]"
      >
        <span class="hidden md:inline">{{
          'rewards.Ganasindays'
            | translate
              : {
                  sign: recentEarningsSign(),
                  ganas: recentEarnings()?.amount | thousandsSeparator,
                  days: recentEarnings()?.days
                }
        }}</span>
        <span class="inline md:hidden">{{
          'rewards.growing'
            | translate: { sign: recentEarningsSign(), ganas: recentEarnings()?.amount | thousandsSeparator }
        }}</span>
      </div>
    }
  </div>
  @if (recentEarningsResource.status() === 'error') {
    <app-resource-load-error data-resource="recent" (retry)="recentEarningsResource.reload()" />
  }
  @if (memberSummaryCardsResource.status() === 'error') {
    <app-resource-load-error
      data-resource="summary"
      message="balance.summaryCardsLoadError"
      (retry)="memberSummaryCardsResource.reload()"
    />
  }
  <div class="flex flex-row gap-4">
    <!-- Card Spending -->
    <div class="flex flex-col px-4 py-5 items-center flex-1 card">
      <div
        class="text-[#00352F] text-[1.1875rem] md:text-[1.75rem]/[140%] font-bold flex flex-wrap items-baseline justify-center gap-x-1"
      >
        @if (memberSummaryCards()) {
          <span class="whitespace-nowrap">{{ cardSpending() | balanceMoney }}</span>
          <span class="text-[0.8125rem] md:text-base font-normal">USD</span>
        } @else {
          —
        }
      </div>
      <span
        class="text-[#017F70] max-w-[5.3rem] md:max-w-none text-center text-[0.8125rem] md:text-[1.125rem]/[160%]"
        >{{ 'balance.cardSpending' | translate }}</span
      >
    </div>
    <!-- Total Leaves -->
    <div class="flex flex-col px-4 py-5 items-center flex-1 card">
      <div class="text-[#003555] text-[1.1875rem] md:text-[1.75rem]/[140%] font-bold">
        {{ memberSummaryCards() ? (totalLeaves() | thousandsSeparator) : '—' }}
      </div>
      <span
        class="text-[#007DCB] max-w-[4.25rem] md:max-w-none text-center text-[0.8125rem] md:text-[1.125rem]/[160%]"
        >{{ 'dashboard.totalLeaves' | translate }}</span
      >
    </div>
    <!-- Growing Ganas -->
    <div class="flex flex-col px-4 py-5 items-center flex-1 card">
      <div class="text-[#642A00] text-[1.1875rem] md:text-[1.75rem]/[140%] font-bold">
        {{ memberSummaryCards() ? (growingGanas() | number: '1.0-0') : '—' }}
      </div>
      <span
        class="text-[#EF6401] max-w-[5.5rem] md:max-w-none text-center text-[0.8125rem] md:text-[1.125rem]/[160%]"
        >{{ 'myGanarbols.potentialGanas' | translate }}</span
      >
    </div>
  </div>
</div>

<div class="grid grid-cols-2 grid-rows-2 md:grid-cols-4 md:grid-rows-1 gap-4 mb-8">
  <!-- Share Ganas -->
  <div
    class="balance-action-card balance-action-card--share card-shadow p-4 md:p-2 flex flex-row md:flex-col gap-2 items-center justify-center md:h-[9rem] flex-1 cursor-pointer"
    (click)="shareGanas()"
  >
    <div
      class="balance-action-card__icon flex flex-col items-center justify-center min-w-[2rem] min-h-[2rem] md:min-w-[3.5rem] md:min-h-[3.5rem] rounded-full"
    >
      <img
        src="../../../../../assets/img/balance/share-ganas.svg"
        class="size-[1.25rem] md:size-[2rem]"
        alt="share-ganas"
      />
    </div>
    <div class="w-full text-left md:text-center">
      <span class="balance-action-card__label text-[0.8125rem] md:text-[1.125rem]/[160%]">{{
        'balance.shareGanas' | translate
      }}</span>
    </div>
  </div>

  <!-- View Transactions -->
  <div
    class="balance-action-card balance-action-card--transactions card-shadow p-4 md:p-2 flex flex-row md:flex-col gap-2 items-center justify-center md:h-[9rem] flex-1 cursor-pointer"
    (click)="viewTransactions()"
  >
    <div
      class="balance-action-card__icon flex flex-col items-center justify-center min-w-[2rem] min-h-[2rem] md:min-w-[3.5rem] md:min-h-[3.5rem] rounded-full"
    >
      <img
        src="../../../../../assets/img/balance/view-transactions.svg"
        class="size-[1.25rem] md:size-[2rem]"
        alt="share-ganas"
      />
    </div>
    <div class="w-full text-left md:text-center">
      <span class="balance-action-card__label text-[0.8125rem] md:text-[1.125rem]/[160%]">{{
        'balance.viewTransactions' | translate
      }}</span>
    </div>
  </div>

  <!-- View Earnings  -->
  <div
    class="balance-action-card balance-action-card--earnings card-shadow p-4 md:p-2 flex flex-row md:flex-col gap-2 items-center justify-center md:h-[9rem] flex-1 cursor-pointer"
    (click)="viewEarnings()"
  >
    <div
      class="balance-action-card__icon flex flex-col items-center justify-center min-w-[2rem] min-h-[2rem] md:min-w-[3.5rem] md:min-h-[3.5rem] rounded-full"
    >
      <img
        src="../../../../../assets/img/balance/view-earnings.svg"
        class="size-[1.25rem] md:size-[2rem]"
        alt="view-earnings"
      />
    </div>
    <div class="w-full text-left md:text-center">
      <span class="balance-action-card__label text-[0.8125rem] md:text-[1.125rem]/[160%]">{{
        'balance.viewEarnings' | translate
      }}</span>
    </div>
  </div>

  <!-- Card Details -->
  <div
    class="balance-action-card balance-action-card--details card-shadow p-4 md:p-2 flex flex-row md:flex-col gap-2 items-center justify-center md:h-[9rem] flex-1 cursor-pointer"
    (click)="cardDetails()"
  >
    <div
      class="balance-action-card__icon flex flex-col items-center justify-center min-w-[2rem] min-h-[2rem] md:min-w-[3.5rem] md:min-h-[3.5rem] rounded-full"
    >
      <img
        src="../../../../../assets/img/balance/card-details.svg"
        class="size-[1.25rem] md:size-[2rem]"
        alt="share-ganas"
      />
    </div>
    <div class="w-full text-left md:text-center">
      <span class="balance-action-card__label text-[0.8125rem] md:text-[1.125rem]/[160%]">{{
        'balance.cardDetails' | translate
      }}</span>
    </div>
  </div>
</div>

<div class="flex flex-col md:flex-row gap-8 w-full">
  <div class="px-6 py-8 min-h-full flex flex-col justify-between items-center gap-6 card w-full md:w-1/2">
    <div class="flex flex-col gap-4 items-center">
      <div class="text-[#2C3035] text-[1.375rem] font-bold">{{ 'balance.browseOurMarketplace' | translate }}</div>
      <img src="../../../../../assets/img/balance/marketplace.svg" alt="marketplace" class="size-[4rem]" />
      <div class="text-[#505760] text-[1.125rem]">{{ 'balance.useYourGanasToCover' | translate }}</div>
    </div>
    <div>
      <korviu-button color="primary" (onclick)="redeem()">{{ 'balance.redeemRewards' | translate }}</korviu-button>
    </div>
  </div>
  <div
    class="card min-h-full justify-between flex flex-col gap-8 items-center w-full md:w-1/2 overflow-hidden"
    [class.px-16]="!earningsSummaryMonths()?.length"
    [class.py-8]="!earningsSummaryMonths()?.length"
  >
    @if (earningsSummaryResource.status() === 'error') {
      <app-resource-load-error data-resource="earnings" (retry)="earningsSummaryResource.reload()" />
    } @else if (!!earningsSummaryMonths()?.length) {
      <div class="flex flex-col gap-4 p-6 w-full">
        <div class="flex flex-col">
          <div class="text-[#2C3035] text-[1.625rem] font-bold">{{ 'balance.ganasEarned' | translate }}</div>
          <div class="text-[#737980] text-[1.125rem]">{{ 'myGanarbols.last6Months' | translate }}</div>
        </div>
        <ng-scrollbar class="w-full" visibility="hover" appearance="compact">
          <div class="w-full overflow-hidden">
            <apx-chart
              class="balance-members__chart block w-full"
              [series]="ganasEarned()?.series"
              [chart]="ganasEarned()?.chart"
              [xaxis]="ganasEarned()?.xaxis"
              [yaxis]="ganasEarned()?.yaxis"
              [plotOptions]="ganasEarned()?.plotOptions"
              [dataLabels]="ganasEarned()?.dataLabels"
              [legend]="ganasEarned()?.legend"
              [tooltip]="ganasEarned()?.tooltip"
              [grid]="ganasEarned()?.grid"
              [colors]="ganasEarned()?.colors"
              [title]="ganasEarned()?.title"
              [subtitle]="ganasEarned()?.subtitle"
              [responsive]="ganasEarned()?.responsive"
              [states]="ganasEarned()?.states"
            />
          </div>
        </ng-scrollbar>
        <div class="flex flex-col">
          <div class="flex items-center gap-1">
            <div class="text-[#505760] text-[1.125rem]">
              {{ earningsTrendTranslationKey() | translate: { count: earningsTrendPercentage() } }}
            </div>
            @if (hasDirectionalEarningsTrend()) {
              <i [class.rotate-90]="earningsTrendDirection() === 'down'">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <path
                    d="M13.7489 6L21.3027 6.00052L21.403 6.01444L21.5018 6.04205L21.5621 6.0676C21.6413 6.10246 21.7155 6.15315 21.7808 6.21836L21.8215 6.2624L21.865 6.31878L21.9192 6.4089L21.9579 6.49922L21.977 6.5633L21.9906 6.6273L22 6.7215L22.0004 14.2539C22.0004 14.6681 21.6647 15.0039 21.2504 15.0039C20.8708 15.0039 20.557 14.7217 20.5073 14.3557L20.5004 14.2539L20.5 8.559L12.7812 16.2793C12.5149 16.5455 12.0982 16.5698 11.8046 16.3519L11.7205 16.2793L8.75001 13.3089L3.28033 18.7786C2.98744 19.0715 2.51256 19.0715 2.21967 18.7786C1.9534 18.5123 1.9292 18.0957 2.14705 17.8021L2.21967 17.7179L8.21967 11.7179C8.48593 11.4517 8.90259 11.4275 9.1962 11.6453L9.28032 11.7179L12.2508 14.6883L19.438 7.5H13.7489C13.3692 7.5 13.0554 7.21785 13.0058 6.85177L12.9989 6.75C12.9989 6.3703 13.2811 6.05651 13.6472 6.00685L13.7489 6Z"
                    [attr.fill]="earningsTrendColor()"
                  />
                </svg>
              </i>
            }
          </div>
          <div class="text-[#737980] text-[0.9375rem]">
            {{ 'balance.showingGanasCollectedForThePast6months' | translate }}
          </div>
        </div>
      </div>
    } @else if (!earningsSummaryResource.isLoading()) {
      <div class="flex flex-col gap-4 items-center">
        <img src="../../../../../assets/img/balance/no-earnings.svg" alt="no-earnings" class="size-[7.75rem]" />
        <div class="text-center text-[#737980] text-[0.9375rem]">{{ 'balance.youHaveNoEarningsYet' | translate }}</div>
      </div>
      <div>
        <korviu-button color="tertiary" (onclick)="getOkeeyCash()">{{
          'balance.getTheOkeeyCashCard' | translate
        }}</korviu-button>
      </div>
    }
  </div>
</div>
